// @ts-nocheck

import React, { useCallback, useMemo } from 'react';

import useMergeProps from '../../hooks/useMergeProps';
import useRouter from '../../hooks/useRouter';
import useScrollUpAvailable from '../../hooks/useScrollUpAvailable';
import { isCatalog } from '../../utils/routes/catalog';
import isHome from '../../utils/routes/isHome';
import isLive from '../../utils/routes/isLive';
import isMatch from '../../utils/routes/isMatch';
import { getAnchorIdByPathname } from '../../utils/scroll';
import { SMOOTH_SCROLL_TIMEOUT, smartScrollToRootAnchor } from '../../utils/smoothScroll';

import ScrollTopFloatingButton from './ScrollTopFloatingButton';

type ScrollTopFloatingButtonContainerProps = {
  className?: string;
};

const ScrollTopFloatingButtonContainer = (ownProps: ScrollTopFloatingButtonContainerProps) => {
  const { location } = useRouter();
  const { pathname } = location;
  const isHomeRoute = useMemo(() => isHome(pathname), [pathname]);
  const isLiveRoute = useMemo(() => isLive(pathname), [pathname]);
  const isCatalogRoute = useMemo(() => isCatalog(pathname), [pathname]);
  const isMatchRoute = useMemo(() => isMatch(pathname), [pathname]);

  const isScrollAvailable = useScrollUpAvailable();

  const isRouteMatching = useMemo(
    () => isHomeRoute || isLiveRoute || isCatalogRoute || isMatchRoute,
    [isHomeRoute, isLiveRoute, isCatalogRoute, isMatchRoute],
  );

  const show = useMemo(() => {
    return isScrollAvailable && isRouteMatching;
  }, [isScrollAvailable, isRouteMatching]);

  const onClick = useCallback(() => {
    const { pathname } = location;
    const anchorId = getAnchorIdByPathname(pathname);

    if (anchorId) {
      smartScrollToRootAnchor(getAnchorIdByPathname(pathname), SMOOTH_SCROLL_TIMEOUT, 0);
    }
  }, [location]);

  const actionsProps = useMemo(() => ({ onClick, show }), [onClick, show]);

  const enhancedProps = useMergeProps({ ownProps, actionsProps });

  return <ScrollTopFloatingButton {...enhancedProps} />;
};

export default ScrollTopFloatingButtonContainer;
